export class PitchToggle {
    private _container: HTMLDivElement | null = null
    private _btn: HTMLButtonElement | null = null
    private _bearing: number
    private _pitch: number
    private _minpitchzoom: number | undefined

    constructor({ bearing = 0, pitch = 70, minpitchzoom } : { bearing?: number, pitch?: number, minpitchzoom?: number}) {
        this._bearing = bearing;
        this._pitch = pitch;
        this._minpitchzoom = minpitchzoom;
    }

    onAdd(map: mapboxgl.Map) {
        this._btn = document.createElement("button");
        this._btn.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d";
        this._btn.type = "button";
        //@ts-ignore
        this._btn["aria-label"] = "Toggle Pitch";
        this._btn.onclick = () => {
            if (map.getPitch() === 0) {
                let options = { pitch: this._pitch, bearing: this._bearing } as mapboxgl.EaseToOptions;
                if (this._minpitchzoom && map.getZoom() > this._minpitchzoom) {
                    options.zoom = this._minpitchzoom;
                }
                map.easeTo(options);
                //@ts-ignore
                this._btn.className =
                    "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d";
            } else {
                map.easeTo({ pitch: 0, bearing: 0 });
                //@ts-ignore
                this._btn.className =
                    "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d";
            }
        };

        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        this._container.appendChild(this._btn);

        return this._container;
    }

    onRemove() {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
            this._container = null
            this._btn = null
        }
    }
}

export class StreetSatelliteToggle {
    private _container: HTMLDivElement | null = null
    private _btn: HTMLButtonElement | null = null
    private _currentStyle: string | undefined

    private _styleParams = [
        {
            name: 'streets',
            btnClassName: 'mapboxgl-ctrl-icon mapboxgl-ctrl-satelliteStreetsToggle',
            btnAriaLabel: 'Toggle SatelliteStreets',
            nextStyle: 'satellite',
            style: 'mapbox://styles/mapbox/satellite-v9'
        },
        {
            name: 'satellite',
            btnClassName: 'mapboxgl-ctrl-icon mapboxgl-ctrl-streetsToggle',
            btnAriaLabel: 'Toggle Streets',
            nextStyle: 'satellite-streets',
            style: 'mapbox://styles/mapbox/satellite-streets-v11'
        },
        {
            name: 'satellite-streets',
            btnClassName: 'mapboxgl-ctrl-icon mapboxgl-ctrl-satelliteStreetsToggle',
            btnAriaLabel: 'Toggle Satellite',
            nextStyle: 'streets',
            style: 'mapbox://styles/wowzaaa-io/cjxeiow9908h51clf8qou5nmr'
        }
    ]

    onAdd(map: mapboxgl.Map) {
        this._currentStyle = 'streets';
        this._btn = document.createElement("button");
        this._btn.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-satelliteToggle";
        this._btn.type = "button";
        //@ts-ignore
        this._btn["aria-label"] = "Toggle Satellite";
        this._btn.onclick = () => {
            // Toggle button always points to the style after the new current style
            const style = this._styleParams.find(item => item.name === this._currentStyle);
            if (style) {
                //@ts-ignore
                this._btn.className = style.btnClassName;
                //@ts-ignore
                this._btn["aria-label"] = style.btnAriaLabel;

                this._currentStyle = style.nextStyle;
                map.setStyle(style.style);
            }
        };

        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        this._container.appendChild(this._btn);

        return this._container;
    }

    onRemove() {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
            this._container = null
            this._btn = null
        }
    }
}